// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3KPfz","row":"styles_row__J_4hM","mainTile":"styles_mainTile__1v4hs","tiles":"styles_tiles__2fxJE"};